import React from 'react';

import {Container} from 'Components/Utilities';
import {Link} from 'Components/Utilities';

import Header from './Header';
import { asset } from "Services/BaseHelpers";

export default class Unauthenticated extends React.Component {
    /**
     * @method render
     * @returns {JSX.Element}
     */
    render () {
        const {
            children,
            title,
            container = true,
            logo = false,
            extraClasses
        } = this.props;

        return (
            <div className={`min-h-screen bg-app-turquoise ${extraClasses}`}>
                {logo &&
                    <img
                        className="mx-auto m-4 max-w-[4em] mb-6 lg:absolute lg:right-10 lg:top-10"
                        src={asset('images/hazard/ee-logo.png')}
                    />
                }

                {container &&
                    <Container>
                        {children}
                    </Container>
                }

                {!container && children}

                <p className="text-center py-4">
                    <Link to="/terms-and-conditions" colour="text-white">
                        Terms And Conditions
                    </Link>
                </p>
            </div>
        )
    };
}
